module.exports = __webpack_public_path__ + "static/media/beta_icon.a8213a4c.svg";